'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _showdown = require('showdown');

var _showdown2 = _interopRequireDefault(_showdown);

var _each = require('lodash/each');

var _each2 = _interopRequireDefault(_each);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _argTypes = require('../../utils/argTypes');

var _argTypes2 = _interopRequireDefault(_argTypes);

require('./TextBox.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var colorOptions = [{ label: 'Dark', value: 'dark' }, { label: 'Light', value: 'light' }];

var fontOptions = [{ label: 'Playfair', value: 'playfair' }, { label: 'Nunito', value: 'nunito' }];

var fontWeightOptions = [{ label: '400 (Nunito)', value: 'fw-400' }, { label: '700 (PlayFair Nunito)', value: 'fw-700' }, { label: '900 (Playfair)', value: 'fw-900' }];

var fontSizeOptions = [{ label: 'XX-Small', value: 'fs-xxsm' }, { label: 'X-Small', value: 'fs-xsm' }, { label: 'Small', value: 'fs-sm' }, { label: 'Medium', value: 'fs-md' }, { label: 'Large', value: 'fs-lg' }, { label: 'X-Large', value: 'fs-xlg' }, { label: 'XX-Large', value: 'fs-xxlg' }, { label: 'XXX-Large', value: 'fs-xxxlg' }, { label: 'XXXX-Large', value: 'fs-xxxxlg' }];

var converter = new _showdown2.default.Converter();
var TextBox = (_temp2 = _class = function (_Component) {
  _inherits(TextBox, _Component);

  function TextBox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextBox.__proto__ || Object.getPrototypeOf(TextBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activatedCopy: ''
    }, _this.activateCopy = function (copy) {
      var sysdata = _this.props.sysdata;
      var copyProps = sysdata.copyProps;


      var activatedCopy = copy;

      (0, _each2.default)(copyProps, function (code) {
        activatedCopy = activatedCopy.split(code.tag).join(code.value);
      });

      return converter.makeHtml(activatedCopy);
    }, _this.activateLinks = function () {
      var sysdata = _this.props.sysdata;
      var callBacks = sysdata.callBacks;


      if (!callBacks) {
        return;
      }

      var anchors = document.querySelectorAll('.react-grid-layout a');

      (0, _each2.default)(anchors, function (link) {
        if (link.id && callBacks[link.id]) {
          link.onclick = callBacks[link.id];
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({ activatedCopy: this.activateCopy(this.props.copy) });
      setTimeout(function () {
        _this2.activateLinks();
      }, 0); // Wait one render frame
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!(0, _isEqual2.default)(this.props, prevProps)) {
        this.setState({ activatedCopy: this.activateCopy(this.props.copy) });
        this.activateLinks();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          font = _props.font,
          fontWeight = _props.fontWeight,
          fontSize = _props.fontSize;
      var activatedCopy = this.state.activatedCopy;


      return _react2.default.createElement(
        'div',
        { className: 'textBox', style: Object.assign({}, this.props.alignment) },
        _react2.default.createElement('div', {
          className: font + ' ' + fontWeight + ' ' + fontSize + ' ' + color,
          style: Object.assign({}, this.props.style),
          dangerouslySetInnerHTML: { __html: activatedCopy }
        })
      );
    }
  }]);

  return TextBox;
}(_react.Component), _class.defaultProps = {
  copy: 'Enter text here...',
  color: 'dark',
  font: 'nunito',
  fontWeight: '400',
  fontSize: 'fs-md',
  sysdata: {}
}, _temp2);
exports.default = TextBox;


TextBox.propTypes = {
  sysdata: _propTypes2.default.shape({}),
  text: _propTypes2.default.string,
  font: _propTypes2.default.string,
  fontWeight: _propTypes2.default.string,
  fontSize: _propTypes2.default.string
};

TextBox.args = [{
  title: 'Text',
  key: 'copy',
  type: _argTypes2.default.TEXT_AREA
}, {
  title: 'Font',
  key: 'font',
  type: _argTypes2.default.SELECT,
  options: fontOptions
}, {
  title: 'Weight',
  key: 'fontWeight',
  type: _argTypes2.default.SELECT,
  options: fontWeightOptions
}, {
  title: 'Size',
  key: 'fontSize',
  type: _argTypes2.default.SELECT,
  options: fontSizeOptions
}, {
  title: 'Color',
  key: 'color',
  type: _argTypes2.default.SELECT,
  options: colorOptions
}];

//# sourceMappingURL=TextBox.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.text-box/dist/components/TextBox/TextBox.js
// module id = 489
// module chunks = 0